import { NgModule } from '@angular/core';
import { LoadAndQueryReportPageComponent } from './pages/report-page.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalVentasComponent } from './modal-ventas/modal-ventas.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [LoadAndQueryReportPageComponent, ModalVentasComponent],
    exports: [LoadAndQueryReportPageComponent],
    imports: [CommonModule, FormsModule, RouterModule, TranslateModule],
})
export class ReporteModule {}
